export const ADVERTISEMENT_URL =
  process.env.REACT_APP_ADVERTISEMENT_URL || "https://testoraglobal.in/account";
